import React from 'react';
import Slider from 'react-slick';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="26"
        viewBox="0 0 40 26"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.428146 13.049C0.428146 12.6731 0.575058 12.3126 0.836571 12.0468C1.09808 11.781 1.45277 11.6316 1.82261 11.6316H34.7124L25.9357 2.71365C25.806 2.58187 25.7032 2.42542 25.633 2.25325C25.5628 2.08107 25.5267 1.89653 25.5267 1.71016C25.5267 1.5238 25.5628 1.33926 25.633 1.16708C25.7032 0.994899 25.806 0.838453 25.9357 0.706673C26.0653 0.574894 26.2192 0.470361 26.3886 0.399042C26.558 0.327723 26.7396 0.291016 26.9229 0.291016C27.1063 0.291016 27.2878 0.327723 27.4572 0.399042C27.6266 0.470361 27.7806 0.574894 27.9102 0.706673L39.0659 12.0455C39.1958 12.1772 39.2988 12.3336 39.3691 12.5058C39.4394 12.678 39.4756 12.8626 39.4756 13.049C39.4756 13.2354 39.4394 13.42 39.3691 13.5922C39.2988 13.7644 39.1958 13.9208 39.0659 14.0525L27.9102 25.3913C27.7806 25.5231 27.6266 25.6276 27.4572 25.699C27.2878 25.7703 27.1063 25.807 26.9229 25.807C26.7396 25.807 26.558 25.7703 26.3886 25.699C26.2192 25.6276 26.0653 25.5231 25.9357 25.3913C25.806 25.2596 25.7032 25.1031 25.633 24.9309C25.5628 24.7588 25.5267 24.5742 25.5267 24.3878C25.5267 24.2015 25.5628 24.0169 25.633 23.8448C25.7032 23.6726 25.806 23.5161 25.9357 23.3844L34.7124 14.4664H1.82261C1.45277 14.4664 1.09808 14.317 0.836571 14.0512C0.575058 13.7854 0.428146 13.4249 0.428146 13.049Z"
          fill="#162C28"
        />
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="26"
        viewBox="0 0 40 26"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.0387 13.049C39.0387 12.6731 38.8917 12.3126 38.6302 12.0468C38.3687 11.781 38.014 11.6316 37.6442 11.6316H4.7544L13.5311 2.71365C13.6608 2.58187 13.7636 2.42542 13.8338 2.25325C13.904 2.08107 13.9401 1.89653 13.9401 1.71016C13.9401 1.5238 13.904 1.33926 13.8338 1.16708C13.7636 0.994899 13.6608 0.838453 13.5311 0.706673C13.4015 0.574894 13.2476 0.470361 13.0782 0.399042C12.9088 0.327723 12.7272 0.291016 12.5439 0.291016C12.3605 0.291016 12.179 0.327723 12.0096 0.399042C11.8402 0.470361 11.6862 0.574894 11.5566 0.706673L0.400887 12.0455C0.271025 12.1772 0.167994 12.3336 0.0976956 12.5058C0.0273967 12.678 -0.00878906 12.8626 -0.00878906 13.049C-0.00878906 13.2354 0.0273967 13.42 0.0976956 13.5922C0.167994 13.7644 0.271025 13.9208 0.400887 14.0525L11.5566 25.3913C11.6862 25.5231 11.8402 25.6276 12.0096 25.699C12.179 25.7703 12.3605 25.807 12.5439 25.807C12.7272 25.807 12.9088 25.7703 13.0782 25.699C13.2476 25.6276 13.4015 25.5231 13.5311 25.3913C13.6608 25.2596 13.7636 25.1031 13.8338 24.9309C13.904 24.7588 13.9401 24.5742 13.9401 24.3878C13.9401 24.2015 13.904 24.0169 13.8338 23.8448C13.7636 23.6726 13.6608 23.5161 13.5311 23.3844L4.7544 14.4664H37.6442C38.014 14.4664 38.3687 14.317 38.6302 14.0512C38.8917 13.7854 39.0387 13.4249 39.0387 13.049Z"
          fill="#162C28"
        />
      </svg>
    </div>
  );
}
const ImageSlider = ({ images }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: images?.length > 1 && <SampleNextArrow />,
    prevArrow: images?.length > 1 && <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="flex w-full">
      <div className="w-full bg-white md:pb-14">
        <Slider {...settings}>
          {images?.map((image, index) => (
            <div key={index} className="px-2 cover-image">
              <img
                src={image?.url}
                alt={`Slide ${index}`}
                className="rounded-md"
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ImageSlider;
